import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import store from '../store'
import TeacherLeaveDetailView from '../views/teacher/TeacherLeaveDetailView.vue'
import {
  getAccessiblePortalSections,
  isPathAllowedBySections
} from '@/utils/portalNavigation'
import {
  getAdminNavSections,
  getDormNavSections,
  getGuardNavSections,
  getStudentCouncilNavSections
} from '@/config/adminNavigation'
import { getTeacherNavSections } from '@/config/teacherNavigation'
import { getGuardHomePath, isGuardLeaveMode, isGuardMoralMode } from '@/config/guardPortal.mjs'

function ensureTeacherHeadTeacherAccess(next, fallback = '/teacher/students') {
  if (store.state.role === 'teacher' && store.state.teacherIsHeadTeacher === false) {
    next(fallback)
    return true
  }
  return false
}

const routes = [
  // 鐧诲綍椤碉紙璺緞涓庡悗绔?POST /login 鍖哄垎锛岄伩鍏嶄唬鐞嗗啿绐侊級
  { path: '/auth/login', name: 'login', component: () => import('../views/LoginView.vue') },
  { path: '/psychology', redirect: '/psychology/home' },
  { path: '/psychology/home', name: 'psychology-room', component: () => import('../views/PsychologyRoomView.vue') },
  { path: '/psychology/appointments', name: 'psychology-appointments', component: () => import('../views/psychology/PsychologyAppointmentsView.vue') },
  { path: '/psychology/settings', name: 'psychology-settings', component: () => import('../views/psychology/PsychologySlotSettingsView.vue') },
  {
    path: '/psychology/appointments/counsel-booking',
    name: 'psychology-counsel-booking',
    component: () => import('../views/psychology/PsychologyCounselBookingView.vue'),
    meta: { psychologyMobileTitle: '心理辅导预约登记表' }
  },
  {
    path: '/psychology/appointments/consult-record',
    name: 'psychology-consult-record',
    component: () => import('../views/psychology/PsychologyConsultRecordView.vue'),
    meta: { psychologyMobileTitle: '心理咨询记录表' }
  },
  {
    path: '/psychology/appointments/consult-records',
    name: 'psychology-consult-records',
    component: () => import('../views/psychology/PsychologyConsultRecordListView.vue'),
    meta: { psychologyMobileTitle: '心理咨询记录表' }
  },
  {
    path: '/psychology/appointments/guidance-records',
    name: 'psychology-guidance-records',
    component: () => import('../views/psychology/PsychologyGuidanceRecordListView.vue'),
    meta: { psychologyMobileTitle: '心理辅导记录表' }
  },
  {
    path: '/psychology/appointments/guidance-record',
    name: 'psychology-guidance-record',
    component: () => import('../views/psychology/PsychologyGuidanceRecordView.vue'),
    meta: { psychologyMobileTitle: '心理辅导记录表' }
  },
  {
    path: '/psychology/appointments/guidance-report',
    name: 'psychology-guidance-report',
    component: () => import('../views/psychology/PsychologyGuidanceReportView.vue'),
    meta: { psychologyMobileTitle: '心理辅导报告' }
  },
  {
    path: '/psychology/appointments/guidance-reports',
    name: 'psychology-guidance-reports',
    component: () => import('../views/psychology/PsychologyGuidanceReportListView.vue'),
    meta: { psychologyMobileTitle: '心理辅导报告' }
  },
  { path: '/psychology/visits', name: 'psychology-visits', component: () => import('../views/psychology/PsychologyVisitsView.vue') },
  {
    path: '/psychology/visits/student/:id',
    name: 'psychology-visit-detail',
    component: () => import('../views/psychology/PsychologyVisitDetailView.vue'),
    meta: { psychologyMobileTitle: '心理室日志详情' }
  },
  {
    path: '/psychology/student/:id',
    name: 'psychology-student-detail',
    component: () => import('../views/psychology/PsychologyStudentDetailView.vue'),
    meta: { psychologyMobileTitle: '心理室日志详情' }
  },
  // 棣栭〉锛堟牴鎹鑹插姩鎬佹樉绀轰笉鍚屽唴瀹癸級
  { path: '/', name: 'dashboard', component: () => import('../views/admin/DashboardView.vue') },
  { path: '/nav', name: 'function-nav', component: () => import('../views/admin/FunctionNavView.vue') },

  // ========== 绠＄悊绔矾鐢?==========
  // 鐝墝璁惧绠＄悊
  { path: '/admin/boards', name: 'board-manage', component: () => import('../views/admin/BoardManageView.vue') },
  { path: '/admin/boards/config', name: 'board-config', component: () => import('../views/admin/BoardConfigView.vue') },
  { path: '/admin/boards/remote-control/:deviceId?', name: 'board-remote-control', component: () => import('../views/admin/BoardRemoteControlView.vue') },
  { path: '/admin/boards/welcome-special', name: 'board-welcome-special-manage', component: () => import('../views/admin/WelcomeSpecialManageView.vue') },
  { path: '/admin/boards/exam-special', name: 'board-exam-special-manage', component: () => import('../views/admin/ExamSpecialManageView.vue') },
  { path: '/admin/boards/detail/:id', name: 'board-detail', component: () => import('../views/admin/BoardDetailView.vue') },
  { path: '/admin/logs', name: 'admin-logs', component: () => import('../views/admin/AdminLogsView.vue') },
  // 鐝骇绠＄悊
  { path: '/admin/classes', name: 'class-manage', component: () => import('../views/admin/ClassManageView.vue') },
  { path: '/admin/classes/dingtalk-sync', name: 'class-dingtalk-sync', component: () => import('../views/admin/DingtalkSyncView.vue') },
  { path: '/admin/classes/detail/:id', name: 'class-detail', component: () => import('../views/admin/ClassDetailView.vue') },
  // 瀛︾敓绠＄悊
  { path: '/admin/students', name: 'student-manage', component: () => import('../views/admin/StudentManageView.vue') },
  { path: '/admin/students/commuters', name: 'commuter-student-manage', component: () => import('../views/admin/CommuterStudentManageView.vue') },
  { path: '/admin/students/face-manage', name: 'student-face-manage', component: () => import('../views/shared/StudentFaceManageView.vue') },
  { path: '/admin/students/face-enrollment', name: 'student-face-enrollment', component: () => import('../views/admin/StudentFaceEnrollmentView.vue') },
  // 鏁欏笀绠＄悊
  { path: '/admin/teachers', name: 'teacher-manage', component: () => import('../views/admin/TeacherManageView.vue') },
  { path: '/admin/school-doctors', name: 'school-doctor-manage', component: () => import('../views/admin/SchoolDoctorManageView.vue') },
  { path: '/admin/psychology-counselors', name: 'psychology-counselor-manage', component: () => import('../views/admin/PsychologyCounselorManageView.vue') },
  { path: '/admin/class-honors', name: 'admin-class-honors', component: () => import('../views/admin/AdminClassHonorView.vue') },
  // 绠＄悊鍛樹腑蹇?
  { path: '/admin/center', name: 'admin-center', component: () => import('../views/admin/AdminPermissionCenterView.vue') },

  // 绠＄悊绔?- 瀹℃壒涓庡痉鑲诧紙鍏ㄦ牎瑙嗚锛?
  { path: '/leave', name: 'leave-list', component: () => import('../views/admin/LeaveListView.vue') },
  { path: '/leave/detail/:id', name: 'leave-detail', component: () => import('../views/admin/LeaveDetailView.vue') },
  { path: '/pickup', name: 'pickup-manage', component: () => import('../views/admin/PickupManageView.vue') },
  { path: '/moral', name: 'moral-manage', redirect: '/moral/records' },
  { path: '/moral/score', name: 'moral-score', component: () => import('../views/admin/MoralEvaluationView.vue') },
  { path: '/moral/report', name: 'moral-report', redirect: '/moral/records' },
  { path: '/moral/records', name: 'moral-all-records', component: () => import('../views/admin/MoralAllRecordsView.vue') },
  { path: '/moral/legacy-score', name: 'moral-legacy-score', component: () => import('../views/admin/MoralLegacyEvaluationView.vue') },
  { path: '/moral/legacy-records', name: 'moral-legacy-records', component: () => import('../views/admin/MoralLegacyRecordsView.vue') },
  { path: '/moral/record/:id', name: 'moral-record-detail', component: () => import('../views/admin/MoralRecordDetailView.vue') },
  { path: '/moral/student/:id', name: 'moral-student-detail', component: () => import('../views/admin/MoralStudentDetailView.vue') },

  // 绠＄悊绔?- 瀹舵牎浜掗€?
  { path: '/home-school', name: 'home-school', component: () => import('../views/admin/HomeSchoolView.vue') },
  { path: '/home-school/relations', name: 'home-school-relations', component: () => import('../views/admin/HomeSchoolRelationsManageView.vue') },
  { path: '/config/home-school-sensitive', name: 'home-school-sensitive', component: () => import('../views/admin/HomeSchoolSensitiveView.vue') },

  // 绠＄悊绔?- 鏁欏涓庨€氱煡
  { path: '/schedule', name: 'schedule', component: () => import('../views/admin/ScheduleView.vue') },
  { path: '/admin/meal/dishes', name: 'meal-dish-manage', component: () => import('../views/admin/MealDishManageView.vue') },
  { path: '/admin/meal/menus', name: 'meal-menu-manage', component: () => import('../views/admin/MealMenuManageView.vue') },
  { path: '/admin/meal/menus/editor', name: 'meal-menu-editor', component: () => import('../views/admin/MealMenuEditorView.vue') },
  { path: '/admin/meal/menus/items', name: 'meal-menu-items', component: () => import('../views/admin/MealMenuItemsView.vue') },
  { path: '/admin/meal/orders', name: 'meal-order-manage', component: () => import('../views/admin/MealOrderManageView.vue') },
  { path: '/admin/meal/orders/detail', name: 'meal-order-detail', component: () => import('../views/admin/MealOrderDetailView.vue') },
  { path: '/notices', name: 'notices', component: () => import('../views/admin/SchoolNoticesView.vue') },
  { path: '/notice-templates', name: 'notice-templates', component: () => import('../views/admin/NoticeTemplatesView.vue') },
  { path: '/news', name: 'school-news', component: () => import('../views/admin/SchoolNewsView.vue') },
  { path: '/news/view/:id', name: 'news-detail', component: () => import('../views/admin/NewsDetailView.vue') },
  { path: '/news/edit/:id', name: 'news-edit', component: () => import('../views/admin/NewsEditView.vue') },
  { path: '/notices/detail/:id', name: 'notice-detail', component: () => import('../views/admin/NoticeDetailView.vue') },
  { path: '/notices/edit/:id', name: 'notice-edit', component: () => import('../views/admin/NoticeEditView.vue') },
  { path: '/homework', name: 'homework-manage', component: () => import('../views/admin/HomeworkManageView.vue') },
  { path: '/ai/chat-sessions', name: 'ai-chat-sessions', component: () => import('../views/shared/AiChatSessionManageView.vue') },
  { path: '/admin/stay-school/attendance', name: 'admin-stay-school-attendance-check', component: () => import('../views/shared/StaySchoolAttendanceCheckView.vue') },
  { path: '/admin/stay-school', name: 'admin-stay-school', component: () => import('../views/admin/StaySchoolManageView.vue') },
  { path: '/admin/stay-school/attendance-records', name: 'admin-stay-school-attendance-records', component: () => import('../views/admin/StaySchoolAttendanceRecordsView.vue') },

  // 绠＄悊绔?- 瀹胯垗涓庤€冨嫟
  {
    path: '/dorm',
    redirect: () => (store.state.role === 'dorm' ? '/dorm/dashboard' : '/admin/dorm/buildings')
  },
  {
    path: '/admin/dorm',
    redirect: '/admin/dorm/buildings'
  },
  { path: '/admin/dorm/center', redirect: '/admin/dorm/buildings' },
  { path: '/admin/dorm/buildings', name: 'dorm-buildings', component: () => import('../views/admin/DormBuildingRoomView.vue') },
  { path: '/admin/dorm/managers', name: 'dorm-managers', component: () => import('../views/admin/DormManagerManageView.vue') },
  { path: '/admin/dorm/assignments', name: 'dorm-assignments', component: () => import('../views/admin/DormAssignmentManageView.vue') },
  { path: '/admin/dorm/sign-in', name: 'dorm-sign-in-manage', component: () => import('../views/admin/DormSignInManageView.vue') },
  { path: '/admin/dorm/inspection', name: 'dorm-inspection-manage', component: () => import('../views/admin/DormInspectionManageView.vue') },
  { path: '/admin/dorm/attendance-config', name: 'dorm-attendance-config', component: () => import('../views/admin/DormAttendanceConfigView.vue') },
  { path: '/admin/dorm/room/:id', name: 'dorm-room-detail', component: () => import('../views/admin/DormRoomDetailView.vue') },
  {
    path: '/dorm/center',
    redirect: to => ({ path: '/admin/dorm/buildings', query: to.query })
  },
  {
    path: '/dorm/buildings',
    redirect: to => ({ path: '/admin/dorm/buildings', query: to.query })
  },
  {
    path: '/dorm/managers',
    redirect: to => ({ path: '/admin/dorm/managers', query: to.query })
  },
  {
    path: '/dorm/assignments',
    redirect: to => ({ path: '/admin/dorm/assignments', query: to.query })
  },
  {
    path: '/dorm/sign-in',
    redirect: to => ({ path: '/admin/dorm/sign-in', query: to.query })
  },
  {
    path: '/dorm/attendance-config',
    redirect: to => ({ path: '/admin/dorm/attendance-config', query: to.query })
  },
  {
    path: '/dorm/room/:id',
    redirect: to => ({ path: `/admin/dorm/room/${to.params.id}`, query: to.query })
  },
  {
    path: '/dorm/applications',
    redirect: to => ({ path: '/admin/dorm/assignments', query: to.query })
  },
  {
    path: '/dorm/detail/:id',
    redirect: to => ({ path: `/admin/dorm/room/${to.params.id}`, query: to.query })
  },
  {
    path: '/dorm/check',
    redirect: to => ({ path: '/admin/dorm/inspection', query: to.query })
  },
  {
    path: '/dorm/check-in',
    redirect: to => ({ path: '/admin/dorm/sign-in', query: to.query })
  },
  {
    path: '/dorm/check-in/bed-detail',
    redirect: to => ({ path: '/admin/dorm/sign-in', query: to.query })
  },
  {
    path: '/dorm/check-in/detail',
    redirect: to => ({ path: '/admin/dorm/sign-in', query: to.query })
  },
  {
    path: '/dorm/check/detail/:id',
    redirect: to => ({ path: '/admin/dorm/inspection', query: { ...to.query, inspection_id: to.params.id } })
  },
  { path: '/attendance', name: 'attendance', component: () => import('../views/admin/AttendanceView.vue') },
  { path: '/attendance/records', name: 'sign-in-records', component: () => import('../views/admin/SignInRecordsView.vue') },
  { path: '/admin/class-access/records', name: 'class-access-records', component: () => import('../views/admin/ClassAccessRecordsView.vue') },
  { path: '/config/attendance-time', name: 'attendance-config', component: () => import('../views/admin/AttendanceConfigView.vue') },
  { path: '/config/semesters', name: 'semester-manage', component: () => import('../views/admin/SemesterManageView.vue') },
  { path: '/config/time-plans', name: 'time-plan-manage', component: () => import('../views/admin/TimePlanManageView.vue') },
  { path: '/config/schedule-time', name: 'schedule-time-config', component: () => import('../views/admin/ScheduleTimeConfigView.vue') },
  { path: '/config/campus-card-sync', name: 'campus-card-sync', component: () => import('../views/admin/CampusCardSyncView.vue') },
  { path: '/config/api-keys', name: 'open-api-key-manage', component: () => import('../views/admin/OpenApiKeyManageView.vue') },

  // 绠＄悊绔?- 绯荤粺閰嶇疆
  { path: '/import/students', name: 'student-import', component: () => import('../views/admin/StudentImportView.vue') },
  { path: '/config/moral-items', name: 'moral-items', component: () => import('../views/admin/MoralItemConfigView.vue') },
  { path: '/config/moral-scores', name: 'moral-scores', component: () => import('../views/admin/MoralScoreConfigView.vue') },
  { path: '/config/notice-scope', name: 'notice-scope', component: () => import('../views/admin/NoticeScopeConfigView.vue') },

  // ========== 鏁欏笀绔矾鐢?==========
  { path: '/teacher/nav', name: 'teacher-function-nav', component: () => import('../views/teacher/TeacherFunctionNavView.vue') },
  { path: '/teacher/students', name: 'teacher-students', component: () => import('../views/teacher/ClassStudentsView.vue') },
  {
    path: '/teacher/students/face-manage',
    name: 'teacher-student-face-manage',
    component: () => import('../views/shared/StudentFaceManageView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next)) return
      next()
    }
  },
  {
    path: '/teacher/students/face-enrollment',
    name: 'teacher-student-face-enrollment',
    component: () => import('../views/admin/StudentFaceEnrollmentView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next)) return
      next()
    }
  },
  { path: '/teacher/board', name: 'teacher-board', component: () => import('../views/teacher/BoardStatusView.vue') },
  { path: '/teacher/board/preview', name: 'teacher-board-preview', component: () => import('../views/teacher/BoardStatusView.vue') },
  { path: '/teacher/leave', name: 'teacher-leave', component: () => import('../views/teacher/TeacherLeaveView.vue') },
  { path: '/teacher/leave/detail/:id', name: 'teacher-leave-detail', component: TeacherLeaveDetailView },
  { path: '/teacher/pickup', name: 'teacher-pickup', component: () => import('../views/teacher/TeacherPickupManageView.vue') },
  { path: '/teacher/pickup/detail/:id', name: 'teacher-pickup-detail', component: () => import('../views/teacher/TeacherPickupDetailView.vue') },
  { path: '/teacher/moral', name: 'teacher-moral', component: () => import('../views/teacher/TeacherMoralView.vue') },
  { path: '/teacher/moral/records', name: 'teacher-moral-records', component: () => import('../views/teacher/TeacherMoralRecordsView.vue') },
  { path: '/teacher/moral/items', name: 'teacher-moral-items', component: () => import('../views/teacher/TeacherMoralItemsView.vue') },
  { path: '/teacher/attendance', name: 'teacher-attendance', redirect: '/teacher/attendance/records' },
  { path: '/teacher/attendance/preview', name: 'teacher-attendance-preview', component: () => import('../views/teacher/TeacherAttendanceView.vue') },
  { path: '/teacher/attendance/records', name: 'teacher-sign-in-records', component: () => import('../views/teacher/TeacherSignInRecordsView.vue') },
  { path: '/teacher/schedule', name: 'teacher-schedule', component: () => import('../views/teacher/TeacherScheduleView.vue') },
  { path: '/teacher/commuters', name: 'teacher-commuter-students', component: () => import('../views/teacher/TeacherCommuterStudentManageView.vue') },
  { path: '/teacher/notices', name: 'teacher-notices', component: () => import('../views/teacher/TeacherNoticesView.vue') },
  { path: '/teacher/homework', name: 'teacher-homework', component: () => import('../views/teacher/TeacherHomeworkView.vue') },
  {
    path: '/teacher/stay-school',
    name: 'teacher-stay-school',
    component: () => import('../views/teacher/TeacherStaySchoolView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next, '/teacher/students')) return
      next()
    }
  },
  {
    path: '/teacher/stay-school/attendance-config',
    name: 'teacher-stay-school-attendance-config',
    component: () => import('../views/teacher/TeacherStaySchoolAttendanceConfigView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next, '/teacher/students')) return
      next()
    }
  },
  {
    path: '/teacher/stay-school/attendance',
    name: 'teacher-stay-school-attendance-check',
    component: () => import('../views/shared/StaySchoolAttendanceCheckView.vue')
  },
  {
    path: '/teacher/stay-school/attendance-records',
    name: 'teacher-stay-school-attendance-records',
    component: () => import('../views/teacher/TeacherStaySchoolAttendanceRecordsView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next, '/teacher/students')) return
      next()
    }
  },
  {
    path: '/teacher/dorm',
    name: 'teacher-dorm',
    component: () => import('../views/teacher/TeacherDormView.vue')
  },
  {
    path: '/teacher/dorm/attendance',
    name: 'teacher-dorm-attendance',
    component: () => import('../views/teacher/TeacherDormAttendanceView.vue')
  },
  {
    path: '/teacher/home-school',
    name: 'teacher-home-school',
    component: () => import('../views/teacher/TeacherHomeSchoolView.vue'),
    beforeEnter: (to, from, next) => {
      if (ensureTeacherHeadTeacherAccess(next, '/')) return
      next()
    }
  },
  { path: '/teacher/class-honors', name: 'teacher-class-honors', component: () => import('../views/teacher/TeacherClassHonorView.vue') },

  // ========== 鍖诲姟瀹ょ璺敱 ==========
  { path: '/medical', redirect: '/medical/home' },
  { path: '/medical/pending', name: 'medical-pending', component: () => import('../views/medical/MedicalPendingView.vue') },
  { path: '/medical/home', name: 'medical-home', component: () => import('../views/medical/MedicalHomeView.vue') },
  { path: '/medical/visits', name: 'medical-visits', component: () => import('../views/medical/MedicalVisitsView.vue') },
  { path: '/medical/notices', name: 'medical-notices', component: () => import('../views/medical/MedicalNoticesView.vue') },
  { path: '/medical/notices/templates', name: 'medical-notice-templates', component: () => import('../views/medical/MedicalNoticeTemplatesView.vue') },
  { path: '/medical/notices/detail/:id', name: 'medical-notice-detail', component: () => import('../views/medical/MedicalNoticeDetailView.vue') },
  { path: '/medical/notices/edit/:id', name: 'medical-notice-edit', component: () => import('../views/medical/MedicalNoticeEditView.vue') },
  { path: '/medical/leave/templates', name: 'medical-leave-templates', component: () => import('../views/medical/MedicalLeaveReasonTemplatesView.vue') },
  { path: '/medical/leave', name: 'medical-leave', component: () => import('../views/medical/MedicalLeaveView.vue') },
  { path: '/medical/leave/detail/:id', name: 'medical-leave-detail', component: () => import('../views/medical/MedicalLeaveDetailView.vue') },
  { path: '/medical/leave/proxy', name: 'medical-proxy-leave', component: () => import('../views/medical/MedicalProxyLeaveView.vue') },
  { path: '/medical/home/create', name: 'medical-visit-create', component: () => import('../views/medical/MedicalVisitCreateView.vue') },
  { path: '/medical/home/student/:id', name: 'medical-student-detail', component: () => import('../views/medical/MedicalStudentDetailView.vue') },

  // ========== 瀛︾敓浼氱璺敱 ==========
  { path: '/student-union', redirect: '/student-union/moral' },
  { path: '/student-union/moral', name: 'student-union-moral', component: () => import('../views/studentCouncil/StudentCouncilMoralDeductionView.vue') },

  // ========== 闂ㄥ崼绔矾鐢?==========
  { path: '/guard', redirect: () => getGuardHomePath() },
  {
    path: '/guard/moral',
    name: 'guard-moral',
    component: () => import('../views/guard/GuardMoralDeductionView.vue'),
    meta: { hideTopBar: true }
  },
  {
    path: '/guard/records',
    name: 'guard-moral-records',
    component: () => import('../views/guard/GuardMoralRecordsView.vue'),
    meta: { hideTopBar: true }
  },

  // ========== 瀹跨绔矾鐢?==========
  { path: '/dorm/dashboard', name: 'dorm-dashboard', component: () => import('../views/dorm/DormFunctionNavView.vue') },
  { path: '/dorm/moral', name: 'dorm-moral', component: () => import('../views/dorm/DormMoralDeductionQuickView.vue') },
  { path: '/dorm/inspection', name: 'dorm-inspection', component: () => import('../views/dorm/DormCheckView.vue') },
  { path: '/dorm/students', name: 'dorm-students', component: () => import('../views/dorm/DormStudentsView.vue') },
  { path: '/dorm/stay-school', name: 'dorm-stay-school', component: () => import('../views/dorm/DormStaySchoolView.vue') },
  { path: '/dorm/students/:id', name: 'dorm-student-detail', component: () => import('../views/dorm/DormStudentDetailView.vue') },
  {
    path: '/dorm/notifications',
    name: 'dorm-notifications',
    redirect: to => ({ path: '/dorm/dashboard', query: to.query })
  },
  {
    path: '/dorm/nav',
    redirect: to => ({ path: '/dorm/dashboard', query: to.query })
  },
  {
    path: '/dorm/check-view',
    redirect: to => ({ path: '/dorm/inspection', query: to.query })
  },
  {
    path: '/dorm/check-view/detail/:id',
    redirect: to => ({ path: `/dorm/students/${to.params.id}`, query: { ...to.query, from: to.query.from || 'inspection' } })
  },
  {
    path: '/dorm/attendance',
    redirect: to => ({ path: '/dorm/dashboard', query: to.query })
  }
]

const createRouterHistory = process.env.VUE_APP_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

const router = createRouter({
  history: createRouterHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

function resolveRoleHome(role) {
  if (role === 'dorm') return '/dorm/dashboard'
  if (role === 'medical') return '/medical/home'
  if (role === 'studentCouncil') return '/student-union/moral'
  if (role === 'guard') return getGuardHomePath()
  if (role === 'admin' || role === 'subadmin') return '/'
  if (role === 'teacher') return '/'
  return '/'
}

function resolvePortalByRole(role) {
  if (role === 'admin' || role === 'subadmin') return 'admin'
  if (role === 'teacher') return 'teacher'
  if (role === 'dorm') return 'dorm'
  if (role === 'studentCouncil') return 'studentcouncil'
  if (role === 'guard') return 'guard'
  if (role === 'medical') return 'medical'
  return ''
}

function getPortalSectionsForRole(role) {
  const portal = resolvePortalByRole(role)
  if (!portal) return []
  return getAccessiblePortalSections(store.state.serverNavigation?.sections || [], portal, {
    adminSections: getAdminNavSections(),
    teacherSections: getTeacherNavSections(),
    dormSections: getDormNavSections(),
    studentCouncilSections: getStudentCouncilNavSections(),
    guardSections: getGuardNavSections(),
    fallbackMode: 'full',
    isHeadTeacher: store.state.teacherIsHeadTeacher !== false
  })
}

function isAlwaysAllowedPath(path, role) {
  if (path === '/auth/login') return true
  if (path === '/psychology' || path.startsWith('/psychology/')) return role === 'admin' || role === 'subadmin' || role === 'teacher'
  if (path === '/') return role === 'admin' || role === 'subadmin' || role === 'teacher'
  if (path === '/teacher/nav' || path === '/nav') return true
  if (path === '/dorm' || path === '/dorm/dashboard') return role === 'dorm'
  if (path === '/medical' || path === '/medical/leave') return role === 'medical'
  if (path === '/student-union' || path === '/student-union/moral') return role === 'studentCouncil'
  if (path === '/guard') return role === 'guard'
  if (path === '/guard/moral') return role === 'guard' && isGuardMoralMode()
  if (isGuardLeaveMode() && (path === '/leave' || path.startsWith('/leave/'))) return role === 'guard'
  return false
}

function hasServerNavigationAccess(path, role) {
  if (isAlwaysAllowedPath(path, role)) return true
  const portal = resolvePortalByRole(role)
  if (!portal || portal === 'medical') return true
  const sections = getPortalSectionsForRole(role)
  if (!sections.length) return false
  return isPathAllowedBySections(path, sections)
}

function getAllowedRolesByPath(path) {
  if (path === '/auth/login') return null
  if (path === '/psychology' || path.startsWith('/psychology/')) return ['admin', 'subadmin', 'teacher']
  if (path === '/') return ['admin', 'subadmin', 'teacher']
  if (path === '/nav') return ['admin', 'subadmin']
  if (path === '/dorm') return ['admin', 'subadmin', 'dorm']
  if (path === '/medical' || path.startsWith('/medical/')) return ['medical']
  if (path === '/student-union' || path.startsWith('/student-union/')) return ['studentCouncil']
  if (path === '/guard' || path.startsWith('/guard/')) return ['guard']
  if (isGuardLeaveMode() && (path === '/leave' || path.startsWith('/leave/'))) return ['admin', 'subadmin', 'guard']
  if (path === '/admin/dorm' || path.startsWith('/admin/dorm/')) return ['admin', 'subadmin']
  if (path === '/teacher' || path.startsWith('/teacher/')) return ['teacher']
  if (
    path === '/dorm/dashboard'
    || path === '/dorm/nav'
    || path === '/dorm/moral'
    || path.startsWith('/dorm/moral/')
    || path === '/dorm/inspection'
    || path.startsWith('/dorm/inspection/')
    || path === '/dorm/check-view'
    || path.startsWith('/dorm/check-view/')
    || path === '/dorm/students'
    || path.startsWith('/dorm/students/')
    || path === '/dorm/stay-school'
    || path.startsWith('/dorm/stay-school/')
    || path === '/dorm/notifications'
    || path.startsWith('/dorm/notifications/')
    || path === '/dorm/attendance'
    || path.startsWith('/dorm/attendance/')
  ) return ['dorm']
  return ['admin', 'subadmin']
}

async function ensureAuthReady() {
  if (store.state.authReady) return
  await store.dispatch('initAuth').catch(() => false)
}

router.beforeEach(async (to) => {
  await ensureAuthReady()

  const isLoggedIn = store.state.isLoggedIn
  const role = store.state.role

  if (to.path === '/auth/login') {
    if (isLoggedIn) {
      return resolveRoleHome(role)
    }
    return true
  }

  if (!isLoggedIn) {
    return {
      path: '/auth/login',
      query: { redirect: to.fullPath }
    }
  }

  if ((role === 'admin' || role === 'subadmin') && to.path === '/dorm/inspection') {
    return {
      path: '/admin/dorm/inspection',
      query: to.query
    }
  }

  if (role === 'guard' && isGuardMoralMode() && (to.path === '/moral/score' || to.path === '/moral/records')) {
    return {
      path: to.path === '/moral/records' ? '/guard/records' : '/guard/moral',
      query: to.query
    }
  }

  const allowedRoles = getAllowedRolesByPath(to.path)
  if (Array.isArray(allowedRoles) && !allowedRoles.includes(role)) {
    return resolveRoleHome(role)
  }

  if (!hasServerNavigationAccess(to.path, role)) {
    return resolveRoleHome(role)
  }

  return true
})

export default router
